var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        width: "700",
        placement: "right-start",
        trigger: "hover",
        "open-delay": 800,
        "close-delay": 500
      },
      on: { "after-enter": _vm.loadData }
    },
    [
      _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
        _c(
          "a",
          {
            class: { _ticket_title_a: _vm.isDashboard },
            attrs: {
              target: _vm.target,
              href: "/ticket/t/" + _vm.ticketNo,
              title: _vm.ticketTitle
            }
          },
          [_vm._v(_vm._s(_vm.ticketTitle ? _vm.ticketTitle : _vm.ticketNo))]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "max-height": "350px", overflow: "auto" } },
        [
          _c("div", { staticClass: "f-box" }, [
            _c(
              "div",
              { staticClass: "_div_10" },
              [
                _c("span", { staticClass: "_label_11" }, [_vm._v("工单编号")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.ticket.orderId))]),
                _vm._v(" "),
                _c("TicketShare", {
                  attrs: { ticket: _vm.ticket, mode: "view" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "_div_10" }, [
              _c("span", { staticClass: "_label_11" }, [_vm._v("创建时间")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticket.createdAt))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "f-box" }, [
            _c("div", { staticClass: "_div_10" }, [
              _c("span", { staticClass: "_label_11" }, [_vm._v("更新时间")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticket.updatedAt))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "_div_10" }, [
              _c("span", { staticClass: "_label_11" }, [_vm._v("截止时间")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.ticket.endAt))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "padding-bottom": "5px" } }, [
            _c("span", { staticClass: "_label_11" }, [_vm._v("最新回复")])
          ]),
          _vm._v(" "),
          !!_vm.ticketEventList
            ? _c("TicketEventList", {
                attrs: { ticketEventList: _vm.ticketEventList }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.ticketEventList
            ? _c(
                "div",
                {
                  staticStyle: { "padding-left": "20px", "font-size": "15px" }
                },
                [_vm._v("加载中...")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44273599", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44273599","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketTitle.vue
// module id = 722
// module chunks = 75